import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let appointments = useDataValue({
    context: 'appointments',
    viewPath: props.viewPath,
  })
  let appointment_id = useDataValue({
    context: 'appointment_overlay',
    path: 'appointment_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let selected = appointments.find(item => item._id === appointment_id)

    return {
      type_color: selected?.type?.display_color_id ?? data.type_color,
      type_name: selected?.type?.display_name ?? data.type_name,
    }
  }, [data, appointments, appointment_id])
}
